import type {ReactElement} from 'react';
import {useId, useState} from 'react';
import type {AiChatQuickTipsCollapsibleCardProps} from './ai-chat-quick-tips-collapsible-card.types';
import styles from './ai-chat-quick-tips-collapsible-card.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {AiChatQuickTipsItemHeaderIcon} from '@AiChat/components/ai-chat-quick-tips/components/ai-chat-quick-tips-item-header-icon/ai-chat-quick-tips-item-header-icon';
import {ClickableDiv} from '@Components/clickable-div';
import {noop} from '@Utils/general.util';

/** The body stays in the DOM while collapsed, so crawlers index it. */
export function AiChatQuickTipsCollapsibleCard({icon, title, titleTag, onExpand = noop, children}: AiChatQuickTipsCollapsibleCardProps): ReactElement {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const bodyId = useId();

  const toggleIsOpen = (): void => {
    if (!isOpen) {
      onExpand();
    }
    setIsOpen(!isOpen);
  };

  return (
    <div className={`bg-neutral-0 border-s-standard radius-12 ${styles.card}`}>
      <ClickableDiv className={`flex-center gap-3 spacing-p-3 _cursor-pointer ${styles.clickableHeader}`} onClick={toggleIsOpen} aria-expanded={isOpen} aria-controls={bodyId}>
        <AiChatQuickTipsItemHeaderIcon icon={icon} />
        <Text tag={titleTag} className={styles.title} size={TextSize.MD} bold val={title} />
        <Icon icon={isOpen ? 'icon-minus' : 'icon-plus'} size={IconSize.SIZE_ICON_16} shape={IconShape.SQUARE} type={IconType.TRANSPARENT} />
      </ClickableDiv>
      <div id={bodyId} hidden={!isOpen} className={'spacing-p-t-0 spacing-p-l-3 spacing-p-r-3 spacing-p-b-4'}>
        {children}
      </div>
    </div>
  );
}
